/**
 * @fileoverview Shapes theme - match different geometric shapes.
 */

import { ThemeOptions } from '../../services/ThemeService.js';
import { BaseTheme, ColorConfig, KonvaNode } from '../abstract/BaseTheme.js';
import type { MatchingPair } from '../../utilities/GameUtils.js';
import { ShapeHelpers } from '../ShapeHelpers.js';

/**
 * Shapes theme with circles, stars, and triangles.
 */
export class ShapesTheme extends BaseTheme {
    readonly id = 'shapes';
    readonly name = 'Shapes';
    readonly shapeType = 'mixed';
    readonly matchType = 'shape';
    readonly shapeTypes = ['circle', 'star', 'triangle', 'square'];

    readonly fillTarget: boolean;
    
    constructor(options: ThemeOptions = {}) {
        let defaultOptions: ThemeOptions = {
            numPairs: 5,
            isPremium: false,
            hasMovement: false,
            fillTarget: true,
        } 
        super({...defaultOptions, ...options});
        this.fillTarget = options.fillTarget ?? true;
    }
    
    getShapeTypeForPair(pair: MatchingPair): string {
        // For mixed themes, use the shape type from the pair
        return pair.shapeType || 'rect';
    }
    
    createShape(x: number, y: number, size: number, color: ColorConfig, _isDraggable: boolean, shapeType?: string): KonvaNode {

        // return ShapeHelpers.createGeometricShape(x, y, size, color, shapeType || 'rect');
        return ShapeHelpers.createGeometricShape(x, y, size, color, shapeType || 'rect');
    }
}

